/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: mojmir.studenovsky@eurowag.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * An enumeration.
 * @export
 * @enum {string}
 */
export enum ShipmentState {
    Active = 'active',
    Negotiating = 'negotiating',
    Accepted = 'accepted',
    InTransport = 'in_transport',
    Completed = 'completed',
    Cancelled = 'cancelled',
    Expired = 'expired'
}

export function ShipmentStateFromJSON(json: any): ShipmentState {
    return ShipmentStateFromJSONTyped(json, false);
}

export function ShipmentStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShipmentState {
    return json as ShipmentState;
}

export function ShipmentStateToJSON(value?: ShipmentState | null): any {
    return value as any;
}

